if (!customElements.get('iyi-article-reader')) {
  customElements.define('iyi-article-reader', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const sidebar = this.querySelector('.iyi-article__sidebar');
      const headings = [...this.querySelectorAll('.iyi-article__body :is(h1,h2,h3)')].filter(heading => heading.textContent.trim());
      if (this.dataset.toc === 'true' && headings.length > 1) {
        const list = sidebar.querySelector('ol');
        list.replaceChildren();
        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = `${this.querySelector('.iyi-article__body').id}-heading-${index + 1}`;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent.trim();
          item.append(link);
          list.append(item);
        });
        sidebar.hidden = false;
        this.classList.add('has-toc');
        const details = sidebar.querySelector('details');
        this.desktopQuery = matchMedia('(min-width: 990px)');
        const setTocState = () => { details.open = this.desktopQuery.matches; };
        setTocState();
        this.desktopQuery.addEventListener('change', setTocState, { signal: this.controller.signal });
        list.addEventListener('click', event => {
          if (event.target.closest('a') && !this.desktopQuery.matches) details.open = false;
        }, { signal: this.controller.signal });
      }
      const copy = this.querySelector('.iyi-article__copy');
      const status = this.querySelector('.iyi-article__copy-status');
      copy.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(new URL(this.dataset.articleUrl, location.origin).href);
          status.textContent = 'Bağlantı kopyalandı';
        } catch {
          status.textContent = 'Bağlantı kopyalanamadı';
        }
        clearTimeout(this.statusTimer);
        this.statusTimer = setTimeout(() => { status.textContent = ''; }, 3000);
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.statusTimer);
    }
  });
}
